import dayjs, { type Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const getHumanReadableDiff = (inputDate: string): string => {
	// Parse the input date
	const date = dayjs(inputDate);
	const now = dayjs(); // Current date and time

	// Calculate the difference dynamically
	const diffInSeconds = now.diff(date, "second");
	const diffInMinutes = now.diff(date, "minute");
	const diffInHours = now.diff(date, "hour");
	const diffInDays = now.diff(date, "day");
	const diffInYears = now.diff(date, "year");

	if (diffInSeconds < 60)
		return `${diffInSeconds} second${diffInSeconds === 1 ? "" : "s"} ago`;
	if (diffInMinutes < 60)
		return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
	if (diffInHours < 24)
		return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
	if (diffInDays < 365)
		return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
	return `${diffInYears} year${diffInYears === 1 ? "" : "s"} ago`;
};

export const readableHumanDate = (
	inputDate: string | Dayjs,
	format = "YYYY-MM-DDTHH:mm:ssZZ",
): string => {
	const date = dayjs(inputDate, format);
	return date.fromNow();
};

export const parseDate = (input: string, format?: string) => {
	const date = dayjs(input, format);
	return date;
};
